import { FC, FormEventHandler } from 'react'
import { SearchField, SearchForm, SearchSubmit } from './styled'
import { IconSearch } from 'components/icons/search'

type Props = {
  value: string
  onChange: (value: string) => void
}

export const Search: FC<Props> = ({ value, onChange }) => {
  const handleSubmit: FormEventHandler<HTMLFormElement> = evt => {
    evt.preventDefault()
  }

  return (
    <SearchForm onSubmit={handleSubmit}>
      <SearchField
        value={value}
        onChange={evt => onChange(evt.target.value)}
        type="search"
      />
      <SearchSubmit type="submit">
        <IconSearch />
      </SearchSubmit>
    </SearchForm>
  )
}
